import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { usePreferredLocationsMutation } from '../api';
import type { LocationQuerySchema } from '../schemas';

export function LocationsSelect({ disabled, ...props }: FormAsyncComboboxProps<LocationQuerySchema>) {
  const getName = useCallback(
    (item?: LocationQuerySchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/settings/preferred-locations/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={usePreferredLocationsMutation}
      disabled={disabled}
    />
  );
}
